import React from 'react'
import { functionalitiesHelper } from '../../../../utils/functionalitiesHelper'
import { ReactComponent as NoFinishedSchedulings } from '../../../../assets/icons/search-disabled.svg'

const { sortObjArrayByValue } = functionalitiesHelper

export const STATUSES = {
  finished: 'Finalizados',
  cancelled: 'Cancelados',
  in_progress: 'Em andamento',
  scheduled: 'Não iniciado',
  no_show: 'Cliente não veio'
}

export const getCharts = (stats) => {
  const { schedulingsByStatus, overbooksByStatus, attendancesByStatus, totalAttendances } = stats

  const FINISHED_STATS = [
    { label: 'Agendamentos', value: schedulingsByStatus.finished ?? 0 },
    { label: 'Encaixes', value: overbooksByStatus.finished ?? 0 }
  ]

  const OVERVIEW_STATS = sortObjArrayByValue([
    { label: STATUSES.finished, value: attendancesByStatus.finished ?? 0, color: '#25B000' },
    { label: STATUSES.cancelled, value: attendancesByStatus.cancelled ?? 0, color: '#C80E3B' },
    { label: STATUSES.in_progress, value: attendancesByStatus.in_progress ?? 0, color: '#4C85D4' },
    { label: STATUSES.scheduled, value: attendancesByStatus.scheduled ?? 0, color: '#FFC180' },
    { label: STATUSES.no_show, value: attendancesByStatus.no_show ?? 0, color: '#FFE0E4' }
  ], 'value', 'label')

  const FINISHED_STATS_SORTED_BY_VALUE = sortObjArrayByValue(FINISHED_STATS, 'value', 'label')

  const FINISHED_SUBTITLES_RULES = {
    hasOne: !!FINISHED_STATS_SORTED_BY_VALUE[0].value && !FINISHED_STATS_SORTED_BY_VALUE[1].value,
    hasNone: !FINISHED_STATS_SORTED_BY_VALUE[0].value && !FINISHED_STATS_SORTED_BY_VALUE[1].value,
    sameAmount: FINISHED_STATS_SORTED_BY_VALUE[0].value === FINISHED_STATS_SORTED_BY_VALUE[1].value
  }

  return {
    finishedTotal: {
      title: attendancesByStatus.finished
        ? `${attendancesByStatus.finished} ${attendancesByStatus.finished === 1 ? 'atendimento finalizado' : 'atendimentos finalizados'}`
        : 'Nenhum atendimento finalizado',
      subtitle: (FINISHED_SUBTITLES_RULES.hasOne)
        ? <>Somente <strong>{FINISHED_STATS_SORTED_BY_VALUE[0].label.toLocaleLowerCase()}</strong> realizados</>
        : (FINISHED_SUBTITLES_RULES.hasNone)
          ? <>Não há agendamentos ou encaixes finalizados.</>
          : (FINISHED_SUBTITLES_RULES.sameAmount)
            ? <>Foi realizada a <strong>mesma quantidade de agendamentos e encaixes</strong></>
            : <>Foram realizados <strong>mais {FINISHED_STATS_SORTED_BY_VALUE[0].label.toLocaleLowerCase()} </strong>
              do que {FINISHED_STATS_SORTED_BY_VALUE[1].label.toLocaleLowerCase()}</>,
      data: attendancesByStatus.finished ? FINISHED_STATS : [],
      icon: FINISHED_SUBTITLES_RULES.hasNone && <NoFinishedSchedulings />
    },
    schedulingOverview: {
      title: 'Visão geral de todos os atendimentos',
      subtitle: `${totalAttendances} ${totalAttendances === 1 ? `${FINISHED_STATS_SORTED_BY_VALUE[0].label.toLocaleLowerCase()} no total` : 'agendamentos e encaixes no total'}`,
      data: OVERVIEW_STATS,
      type: 'list'
    }
  }
}
